import * as React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { classes } from '../utils/Classes';
import { RemoveIcon } from '@estee/elc-icons';
import { breakpoint } from '@estee/elc-base-theme';
import { translate, ITranslationsCollection } from '@estee/elc-service';
import { transparentButton } from '../../theme/default-theme';

const CloseSearchIconWrapper = styled.button`
    order: 1;
    .elc-search-close-icon {
        height: 15px;
        width: 15px;
    }

    ${transparentButton}
    ${breakpoint('desktop')`
        order: 0;
        position: absolute;
        right: 12px;
        top: 12px;
        [dir='rtl'] & {
            left: 12px;
        }
    `};
`;

export interface IOverlayIconProps {
    toggleSearchOverlay(): void;
    translations?: ITranslationsCollection;
}

const searchIconCloseWrapperClassnames = classes('search-close-icon-wrapper');
const searchIconCloseClassnames = classes('search-close-icon');

export const SearchCloseActiveScreen = translate(['closeLabel', 'searchButtonLabel'])(
    observer((props: IOverlayIconProps) => {
        const translations = props.translations as ITranslationsCollection;
        const { closeLabel, searchButtonLabel } = translations;
        const { toggleSearchOverlay } = props;

        return (
            <CloseSearchIconWrapper
                className={searchIconCloseWrapperClassnames}
                onClick={toggleSearchOverlay}
                aria-label={`${closeLabel} ${searchButtonLabel}`}
                data-test-id="SEA-Close"
                title={`${closeLabel} ${searchButtonLabel}`}
            >
                <RemoveIcon className={searchIconCloseClassnames} />
            </CloseSearchIconWrapper>
        );
    })
);
